<script lang="ts">
    import cn from 'classnames';
    import { sendStoriesEvent } from '$lib/services/gtm/methods';

    import type { StoryFeedItem } from '@api/story/types';
    import { CustomIcon, getIcon } from '@components/icons';
    import { storyFeedStore } from '@components/story/feed';
    import { URLS } from '@shared/routing';
    import { EventType } from '@shared/types';
    import { ReportSource } from '@shared/types/report';
    import { Button, ButtonTypes } from '@uikit/button';
    import { IconName } from '@uikit/svg-icon';

    import s from './controls.module.css';

    import { goto } from '$app/navigation';

    export let nextSlide: () => void;
    export let prevSlide: () => void;
    export let onClose: () => void = () => { /** @noop **/ };
    export let story: StoryFeedItem;
    export let userId: string | null = null;
    export let disablePrev: boolean | undefined = false;

    let isMute: boolean;
    $: isMute = $storyFeedStore.isMute;

    const closeStoryFeed = () => {
        onClose();
        goto(URLS.storyClose());
    };

    const toggleMute = () => {
        sendStoriesEvent({ event: isMute ? EventType.StoriesSoundOn : EventType.StoriesSoundOff });
        storyFeedStore.setMute(!isMute);
    };
</script>

<div class={s.root}>
    <Button
        classes={s.button}
        color={ButtonTypes.Color.Secondary}
        icon={IconName.CloseSmall}
        rounded
        on:click={closeStoryFeed}
    />
    <Button
        classes={s.button}
        color={ButtonTypes.Color.Secondary}
        icon={isMute
            ? getIcon(CustomIcon.muteOn)
            : getIcon(CustomIcon.muteOff)}
        rounded
        on:click={toggleMute}
    />
    {#await
        Promise.all([
            import('@components/user-list-item/report'),
            import('@components/room/reportReasons/dialog/types'),
        ]) then [{ Report }, { ReportReasonPlace }]}
        <Report
            isAuth={userId !== null}
            sourceId={story.id}
            source={ReportSource.Story}
            place={ReportReasonPlace.Story}
            buttonClasses={s.button}
            buttonColor={ButtonTypes.Color.Secondary}
        />
    {/await}
    <div class={s.buttonCenterContainer}>
        <Button
            classes={cn(s.button, s.revertIcon)}
            color={ButtonTypes.Color.Secondary}
            icon={IconName.ArrowDownShort}
            rounded
            on:click={prevSlide}
            disabled={disablePrev}
        />
        <Button
            classes={s.button}
            color={ButtonTypes.Color.Secondary}
            icon={IconName.ArrowDownShort}
            rounded
            on:click={nextSlide}
        />
    </div>
</div>
